/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_NeonInputs */

const en_vc_shots_neon = /** @type {(inputs: Vc_Shots_NeonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft editing a neon poster with live Outer Glow, type styles and the Appearance panel`)
};

const zh_vc_shots_neon = /** @type {(inputs: Vc_Shots_NeonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 VectorCraft 中编辑霓虹海报：实时外发光、文字样式和外观面板`)
};

/**
* | output |
* | --- |
* | "VectorCraft editing a neon poster with live Outer Glow, type styles and the Appearance panel" |
*
* @param {Vc_Shots_NeonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_neon = /** @type {((inputs?: Vc_Shots_NeonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_NeonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_neon(inputs)
	return zh_vc_shots_neon(inputs)
});
export { vc_shots_neon as "vc.shots.neon" }